import { useState, useEffect, useRef } from "react";
import apiClient from "../../../api/apiClient";
import { useIndexPageData } from "../../../contextapi/Indexpagedata";
import { matchOptionId, toCategoryId } from "../utils/helpers";

export const useStep2Data = (stepperFormdata) => {
  const [subcategory, setsubCategory] = useState([]);
  const { nestedSubCategories, categories } = useIndexPageData();
  const [filteredSubSubcategories, setFilteredSubSubcategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(false);
  const productsFetchIdRef = useRef(0);
  const [printingPoducts, setPrintingPoducts] = useState(
    JSON.parse(localStorage.getItem("print_providers")) || []
  );

  const filterSubSubCategories = (subCategoryId) => {
    const filteredSubSubCategories = nestedSubCategories?.filter(
      (subSubCategory) =>
        String(subSubCategory?.subcategory) === String(subCategoryId)
    );
    setFilteredSubSubcategories(filteredSubSubCategories || []);
  };

  const getproductdata = async () => {
    const result = await apiClient.get(`/print-providers/`);
    if (result.ok) {
      setPrintingPoducts(result?.data?.results);
      localStorage.setItem(
        "print_providers",
        JSON.stringify(result?.data?.results)
      );
    }
  };

  const buildProductsCacheKey = ({
    provider_id,
    category,
    subcategory,
    subsubcategory,
  }) => {
    return `products_${provider_id || ""}_${category || ""}_${
      subcategory || ""
    }_${subsubcategory || ""}`;
  };

  const getFilteredProducts = async (linked_print_provider) => {
    const fetchId = ++productsFetchIdRef.current;
    setProductsLoading(true);

    const { category, subcategory, subsubcategory } = stepperFormdata || {};

    const cacheKey = buildProductsCacheKey({
      provider_id: linked_print_provider,
      category,
      subcategory,
      subsubcategory,
    });

    const cachedData = localStorage.getItem(cacheKey);
    if (cachedData) {
      const parsed = JSON.parse(cachedData);
      setProducts(parsed.products || []);
    }

    const params = new URLSearchParams();
    if (linked_print_provider)
      params.append("provider_id", linked_print_provider);
    if (category) params.append("category_id", category);
    if (subcategory) params.append("subcategory_id", subcategory);
    if (subsubcategory) params.append("subsubcategory_id", subsubcategory);

    try {
      const result = await apiClient.get(`/products/?${params.toString()}`);
      if (result.ok) {
        const payload = {
          filters: {
            provider_id: linked_print_provider || null,
            category: category || null,
            subcategory: subcategory || null,
            subsubcategory: subsubcategory || null,
          },
          products: result?.data || [],
          cachedAt: Date.now(),
        };

        localStorage.setItem(cacheKey, JSON.stringify(payload));
        setProducts(result?.data || []);
      }
    } catch (error) {
      console.error("Error fetching filtered products:", error);
    } finally {
      if (fetchId === productsFetchIdRef.current) {
        setProductsLoading(false);
      }
    }
  };

  // Restore subcategory options when editing an existing listing
  useEffect(() => {
    const categoryId = toCategoryId(stepperFormdata?.category);
    if (!categoryId || !categories?.length) {
      if (!categoryId) setsubCategory([]);
      return;
    }

    const selectedCategory = categories.find(
      (cat) => String(cat.id) === String(categoryId)
    );
    setsubCategory(selectedCategory?.subcategories || []);
  }, [categories, stepperFormdata?.category]);

  useEffect(() => {
    const subcategoryId = toCategoryId(stepperFormdata?.subcategory);
    if (subcategoryId && nestedSubCategories) {
      filterSubSubCategories(subcategoryId);
    } else {
      setFilteredSubSubcategories([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nestedSubCategories, stepperFormdata?.subcategory]);

  useEffect(() => {
    getproductdata();
  }, []);

  useEffect(() => {
    if (stepperFormdata?.linked_print_provider && printingPoducts.length > 0) {
      getFilteredProducts(stepperFormdata?.linked_print_provider);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [printingPoducts, stepperFormdata?.linked_print_provider]);

  return {
    subcategory,
    setsubCategory,
    categories,
    filteredSubSubcategories,
    products,
    productsLoading,
    printingPoducts,
    filterSubSubCategories,
    getFilteredProducts,
    categorySelectValue: matchOptionId(categories, stepperFormdata?.category),
    subcategorySelectValue: matchOptionId(
      subcategory,
      stepperFormdata?.subcategory
    ),
    subsubcategorySelectValue: matchOptionId(
      filteredSubSubcategories,
      stepperFormdata?.subsubcategory
    ),
  };
};
